.not-found-page {
  min-height: 100vh;
}

.not-found-page__content {
  min-height: calc(100vh - 160px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 6rem 1.5rem;
  gap: 1rem;
}

.not-found-page__eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.2em;
  opacity: 0.7;
  margin: 0;
}

.not-found-page__title {
  font-size: clamp(2.4rem, 5vw, 4.5rem);
  line-height: 0.95;
  margin: 0;
}

.not-found-page__link {
  text-decoration: none;
}
